import { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  errorId: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorId: ''
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true, errorId: Math.random().toString(36).substring(2, 9) };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 text-slate-900">
          <div className="flex flex-col items-center max-w-md p-8 bg-white border border-slate-200 rounded-lg shadow-sm text-center">
            <AlertTriangle className="w-12 h-12 text-slate-500 mb-4" />
            <h1 className="text-xl font-semibold mb-2 text-slate-800">Something went wrong</h1>
            <p className="text-sm text-slate-500 mb-6">
              An unexpected error has occurred. (Error ID: {this.state.errorId})
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-slate-900 text-slate-50 hover:bg-slate-800 transition-colors rounded font-medium text-sm"
            >
              Reload Application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
